import * as _ from 'lodash'
import {ModelingSessionBO} from "./ModelingSessionBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {
    WB_CustomerCalendarRow,
    WB_CustomerDistributionRelationshipRow,
    WB_CustomerExternalRelationshipRow,
    WB_CustomerProxyRelationshipRow,
    WB_CustomerRelationshipRow,
    WB_ModelCannibalizationRelationshipRow, WB_ModelCannibalizationTypeRow,
    WB_ModelingSessionASRRow,
    WB_ModelingSessionCannMRRow,
    WB_ModelingSessionCannPMRRow, WB_ModelingSessionElRow,
    WB_ModelingSessionRangeRow,
    WB_ModelingSessionRow,
    WB_ModelingSessionTagRuleRRow, WB_ModelTermRelationshipRow, WB_ModelTermRow,
    WB_PowerMetricRelationshipRow,
    WB_PowerMetricRow,
    WB_TagRow
} from "../PA.Core/PAdbSchemaRows";
import {PASearch} from "../PA.Core/PASearch";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Modeling_Session} from "../PA.Core/PAdbSchema";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {CustomerBO} from "../PA.MD.BusinessObjects/CustomerBO";


export class ModelingSessionBOValidations {

    static Validate(aBO: ModelingSessionBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            ModelingSessionBOValidations.ValidateTaggingRules(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateExecutionSetup(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateCoefficientRanges(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidatePowerMetricWeight(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateOverlapDates(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateStockPeriods(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateElasticities(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return ModelingSessionBOValidations.ValidateIntelligentIntercept(aBO)
                    resolve()
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static ValidateTaggingRules(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            /*let arrTagRuleRRows: WB_ModelingSessionTagRuleRRow[] = aBO.WB_ModelingSession.WB_ModelingSessionTagRuleRRows
            let dctWBTagIds = _.keyBy(_.map(arrTagRuleRRows, (aTagRuleRRow: WB_ModelingSessionTagRuleRRow) => {
                return aTagRuleRRow.WB_TagRow
            }), "WB_TAG_ID")

            _.forEach(dctWBTagIds, (aTagRow: WB_TagRow) => {
                let arrTagRules = aTagRow.WB_TagRuleRows
                let dctTagRuleIds = _.keyBy(arrTagRules, "WB_TAG_RULE_ID")
                let arrActiveRules = _.filter(arrTagRuleRRows, (aTagRuleRRow: WB_ModelingSessionTagRuleRRow) => {
                    return aTagRuleRRow.cif.ACTIVE_IND == '1' && aTagRuleRRow.cif.WB_TAG_RULE_ID in dctTagRuleIds
                })

                if (arrActiveRules.length < 1) {
                    ErrorMessage_restate(aBO.ValidateMessageProvider,
                        true,
                        'AtleastOneRulePerTagNotActive',
                        "At least 1 rule has to be activated per Tag the model requires. Tag " + aTagRow.cif.TAG_NAME + " doesn't have any active rules.")
                }
            })*/
            resolve()
        })
    }

    static ValidateExecutionSetup(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let perSubModelTimeLimit = aBO.WB_ModelingSession.STOP_SUBTRIAL_HRS_MINS
            let totalTimeLimit = aBO.WB_ModelingSession.STOP_TRIAL_HRS_MINS
            if(totalTimeLimit <= perSubModelTimeLimit) {
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'SubTrialTimeLimitMoreThanTotal',
                    "Time limit per sub-model should be less than Time limit per model")
            }

            if (totalTimeLimit < 1 || perSubModelTimeLimit<1 && aBO.WB_ModelingSession.cif.STOP_SUBTRIAL_HRS_IND === '1'){
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'TimeLimitDuration',
                    "Time limit per sub-model (minutes) must be > 1 minute")
            }


            if ( aBO.WB_ModelingSession.cif.STOP_SUBTRIAL_CANN_NOI<1000  && aBO.WB_ModelingSession.cif.STOP_SUBTRIAL_CANN_NOI_IND === '1'){
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'MaximumIterations',
                    "Maximum Iterations per Cannibalization sub-model should be >= 1000 Iterations")
            }

            if ( aBO.WB_ModelingSession.cif.STOP_MAX_REFINEMENT_NOI<5){
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'MaxRefinements',
                    "Max Passes of Refinements should be >= 5 Iterations")
            }

            if ( aBO.WB_ModelingSession.cif.STOP_SUBTRIAL_NOI<0){
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'MaxRefinements',
                    "Max iterations per model cannot be a negative number")
            }



            resolve()
        })
    }

    static ValidateCoefficientRanges(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let arrCoefficientRangeRows: WB_ModelingSessionRangeRow[] = aBO.WB_ModelingSession.WB_ModelingSessionRangeRows
            let arrInvalidRange: string[] = []

            _.forEach(arrCoefficientRangeRows, (aRangeRow: WB_ModelingSessionRangeRow) => {
                let minValue = aRangeRow.cif.COEFFICIENT_MIN_VALUE
                let maxValue = aRangeRow.cif.COEFFICIENT_MAX_VALUE

                if (minValue > maxValue) {
                    arrInvalidRange.push(aRangeRow.WB_ModelCoefficientRow.cif.MODEL_COEFFICIENT_ID)
                }
            })

            _.forEach(arrInvalidRange, (aCoeff: string) => {
                ErrorMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'InvalidCoefficientRange',
                    "Coefficient " + aCoeff + " has min value greater than the max value.")
            })

            resolve()
        })
    }

    static ValidatePowerMetricWeight(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let cannMRRows: WB_ModelingSessionCannMRRow[] = aBO.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows

            _.forEach(cannMRRows, (aRelRow: WB_ModelingSessionCannMRRow) => {
                let powerMetricRels: WB_ModelingSessionCannPMRRow[] = aRelRow.WB_ModelingSessionCannPMRRows

                let totalWeight = 0
                _.forEach(powerMetricRels, (aRel: WB_ModelingSessionCannPMRRow) => {
                    if (aRel.cif.DELETED_IND != "1") {
                        let weightVal = _.toNumber(aRel.cif.WEIGHT)
                        totalWeight = totalWeight + weightVal
                    }
                })

                if (totalWeight != 1) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'totalWeightNot1',
                            type: MessageType.Error,
                            title: 'Total weight for power metric(s) assigned to Cannibalization Type: ' + aRelRow.WB_ModelCannibalizationTypeRow.cif.CANNIBALIZATION_TYPE_NAME + ' must be equal to 1',
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                }
            })
            resolve()
        })
    }

    static ValidateOverlapDates(aBO: ModelingSessionBO): Promise<void> {

        return new Promise((resolve, reject) => {
            let bOverLap = false
            let tStartDt = DateUtils.convertFromSAPBW(aBO.WB_ModelingSession.cif.START_DT)
            let tEndDt = DateUtils.convertFromSAPBW(aBO.WB_ModelingSession.cif.END_DT)
            let hStartDt = DateUtils.convertFromSAPBW(aBO.WB_ModelingSession.cif.HOLDOUT_START_DT)
            let hEndDt = DateUtils.convertFromSAPBW(aBO.WB_ModelingSession.cif.HOLDOUT_END_DT)

            if (hStartDt || hEndDt) {
                if (_.isUndefined(hStartDt)) {
                    aBO.ValidateMessageProvider.addMessage({
                        code: 'holdOutStart',
                        type: MessageType.Error,
                        title: 'Holdout period start date range cannot be empty',
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                }
                if (_.isUndefined(hEndDt)) {
                    aBO.ValidateMessageProvider.addMessage({
                        code: 'holdOutEnd',
                        type: MessageType.Error,
                        title: 'Holdout period end date range cannot be empty',
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                }
            }
            if (hStartDt && hEndDt && tStartDt && tEndDt) {
                if ((DateUtils.RangeDatesOverlap(tStartDt, tEndDt, hStartDt, hEndDt))) {
                    aBO.ValidateMessageProvider.addMessage({
                        code: 'holdOutRange',
                        type: MessageType.Error,
                        title: 'Holdout period date range cannot overlap with the training date range',
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                }
            }
            if (_.isEmpty(aBO.WB_ModelingSession.cif.START_DT) || _.isEmpty(aBO.WB_ModelingSession.cif.END_DT)) {
                aBO.ValidateMessageProvider.addMessage({
                    code: 'emptyTDates',
                    type: MessageType.Error,
                    title: 'Training Date Range is required. Please enter a valid date range',
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }

            if ((DateUtils.isGreaterThan(hStartDt, hEndDt))) {
                aBO.ValidateMessageProvider.addMessage({
                    code: 'greateroverlap',
                    type: MessageType.Error,
                    title: 'Holdout period start date cannot be greater than end date',
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }

            if ((DateUtils.isGreaterThan(tStartDt, tEndDt))) {
                aBO.ValidateMessageProvider.addMessage({
                    code: 'greateroverlap',
                    type: MessageType.Error,
                    title: 'Training period start date cannot be greater than end date',
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }
            resolve()
        })

    }

    static ValidateStockPeriods(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let cannMRRows: WB_ModelingSessionCannMRRow[] = _.filter(aBO.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, aRow => aRow.isActive)

            _.forEach(cannMRRows, (aRelRow: WB_ModelingSessionCannMRRow) => {
                let affinitySetRelRows: WB_ModelingSessionASRRow[] = _.filter(aRelRow.WB_ModelingSessionASRRows, aRow => aRow.isActive)
                if (affinitySetRelRows.length) {

                    let stockPeriod: any
                    _.forEach(affinitySetRelRows, (aRel: WB_ModelingSessionASRRow) => {
                        stockPeriod = _.toNumber(aRel.cif.STOCKPILING_PERIODS)


                        const rgx = /^(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*)))$/;

                        if (stockPeriod !== 0) {
                            if (!_.isUndefined(stockPeriod) && !rgx.test(stockPeriod)) {
                                aBO.ValidateMessageProvider.addMessage(
                                    {
                                        code: 'period',
                                        type: MessageType.Error,
                                        title: 'Please enter valid whole number in Stockpiling Periods',
                                        description: "",
                                        subtitle: "",
                                        count: 0
                                    })
                            }

                            let maxTimeOffset: number = 0
                            if (!_.isUndefined(aRelRow.WB_ModelCannibalizationRelationshipRow) && !_.isUndefined(aRelRow.WB_ModelCannibalizationRelationshipRow.WB_ModelFunctionDecayRow))
                                maxTimeOffset = aRelRow.WB_ModelCannibalizationRelationshipRow.WB_ModelFunctionDecayRow.cif.PERIOD_OFFSET_MAX

                            if (_.gt(stockPeriod, maxTimeOffset)) {
                                aBO.ValidateMessageProvider.addMessage(
                                    {
                                        code: 'greaterStockPeriod',
                                        type: MessageType.Error,
                                        title: `You cannot enter a week that is greater than the ${maxTimeOffset} for max time period offset.`,
                                        description: "",
                                        subtitle: "",
                                        count: 0
                                    })
                            }
                        }

                    })
                }
            })

            resolve()
        })
    }

    static ValidateElasticities(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let arrElRows: WB_ModelingSessionElRow[] = _.filter(aBO.WB_ModelingSession.WB_ModelingSessionElRows, (aRow: WB_ModelingSessionElRow) => aRow.isActive)

            _.forEach(arrElRows, (anELRow: WB_ModelingSessionElRow) => {
                let lowerBound = anELRow.cif.CALC_VALUE_LOWERBOUND_PCT
                let upperBound = anELRow.cif.CALC_VALUE_UPPERBOUND_PCT
                let predictorName = anELRow.WB_ModelPredictorRow.cif.MODEL_PREDICTOR_NAME

                if (lowerBound > upperBound) {
                    ErrorMessage_restate(aBO.ValidateMessageProvider,
                        true,
                        'UpperBoundLessThanLowerBound',
                        "For predictor: " +predictorName+ " lower bound is greater than the upper bound.")
                }
                if (lowerBound < 0 || upperBound < 0) {
                    ErrorMessage_restate(aBO.ValidateMessageProvider,
                        true,
                        'UpperBoundLessThanLowerBound',
                        "For predictor: " +predictorName+ " lower/upper bounds cannot be less than 0.")
                }
            })
            resolve()
        })
    }

    static ValidateIntelligentIntercept(aBO: ModelingSessionBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

            let modelRow = aBO.WB_ModelingSession.WB_ModelRow
            let modelTerms: WB_ModelTermRow[] = _.map(
                _.filter(modelRow.WB_ModelTermRelationshipRows, (aRow: WB_ModelTermRelationshipRow) => aRow.isActive), (aRow) => aRow.WB_ModelTermRow)

            let interceptTerms = _.filter(modelTerms, (aTerm: WB_ModelTermRow) => aTerm.cif.TERM_TYPE.toLowerCase() == "intercept")
            let prevIntelligentInterceptVal = aBO.WB_ModelingSession.previous("INTELLIGENT_INTERCEPT")

            if(interceptTerms.length > 1 && prevIntelligentInterceptVal == '1') {
                aBO.ValidateMessageProvider.addMessage({
                    code: 'InterceptMessage',
                    type: MessageType.Information,
                    title: "The Model assigned to this session has more than one term with term type “Intercept” set, so Intelligent Intercept Calculation cannot be performed. The Intelligent Intercept Refinement Setting has been deactivated.",
                    description: "",
                    subtitle: "",
                    count: 0
                })
            }
            if(interceptTerms.length == 0 && prevIntelligentInterceptVal == '1') {
                aBO.ValidateMessageProvider.addMessage({
                    code: 'InterceptMessage',
                    type: MessageType.Information,
                    title: "The Model assigned to this session does not have any terms with term type “Intercept” set, so Intelligent Intercept Calculation cannot be performed. The Intelligent Intercept Refinement Setting has been deactivated.",
                    description: "",
                    subtitle: "",
                    count: 0
                })
            }

            resolve()
        })
    }


}
